import React from 'react';
import PropTypes from 'prop-types';
import { Modal as RomboModal } from '@getro/rombo';

export const SimplifiedModal = (props) => {
  const { 'data-testid': dataTestId, title, isOpen, onCancel, content, actions, variant, children } = props;
  let size = 'md';
  if (variant === 'small') {
    size = 'small';
  } else if (variant === 'large') {
    size = 'large';
  }

  return (
    <RomboModal data-testid={dataTestId} isOpen={isOpen} onCancel={onCancel} title={title} size={size}>
      {content || children}
      {actions}
    </RomboModal>
  );
};

SimplifiedModal.propTypes = {
  isOpen: PropTypes.bool,
  'data-testid': PropTypes.string,
  title: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  // eslint-disable-next-line consistent-return
  content: (props, propName, componentName) => {
    if (!props.content && !props.children) {
      return new Error(`One of props 'content' or 'children' was not specified in '${componentName}'.`);
    }
  },
  // eslint-disable-next-line consistent-return
  children: (props, propName, componentName) => {
    if (!props.content && !props.children) {
      return new Error(`One of props 'content' or 'children' was not specified in '${componentName}'.`);
    }
  },
  actions: PropTypes.node,
  variant: PropTypes.oneOf(['large', 'small']),
};

SimplifiedModal.defaultProps = {
  'data-testid': null,
  title: null,
  isOpen: true,
  variant: 'large',
  actions: null,
  content: '',
  children: '',
};
